import './App.css';
import AppRouter from './app/router';

function App() {
  return (
    <div className="App">
      <main>
        <AppRouter />
      </main>
    </div>
  );
}

export default App;
